import { render, staticRenderFns } from "./officeSuppliesPurchaseList.vue?vue&type=template&id=5a8d08b3&scoped=true"
import script from "./officeSuppliesPurchaseList.vue?vue&type=script&lang=js"
export * from "./officeSuppliesPurchaseList.vue?vue&type=script&lang=js"
import style0 from "./officeSuppliesPurchaseList.vue?vue&type=style&index=0&id=5a8d08b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8d08b3",
  null
  
)

export default component.exports